import { QBadge, QBox, QStack, QText } from '@qualio/ui-components';

import { TemplateParent } from '../../../api/templateApi';
import { InheritedParentIcon } from '../InheritedParentIcon/InheritedParentIcon';

const TypeItemlabel = ({
  templateId,
  templatePrefix,
  templateName,
  parent,
  maxWidth,
}: {
  templateId: number;
  templatePrefix: string;
  templateName: string;
  parent?: TemplateParent | null;
  maxWidth?: string;
}) => {
  return (
    <QStack direction="row" alignItems="center">
      <QBox>
        <QBadge
          title={templatePrefix}
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
          textTransform="none"
          boxShadow="none"
        >
          {templatePrefix}
        </QBadge>
      </QBox>
      <QText
        title={templateName}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        maxWidth={maxWidth}
      >
        {templateName}
      </QText>
      {parent && (
        <InheritedParentIcon
          dataCy={`inherited-template-icon-${templateId}`}
          parentName={parent.name}
        />
      )}
    </QStack>
  );
};

export default TypeItemlabel;
